'use strict';

var Document = require('./Document');
var React = require('react');

var _require = require('react-redux'),
    Provider = _require.Provider;

var _require2 = require('react-router'),
    RouterContext = _require2.RouterContext,
    match = _require2.match;

var _require3 = require('react-dom/server'),
    renderToString = _require3.renderToString,
    renderToStaticMarkup = _require3.renderToStaticMarkup;

var _require4 = require('path'),
    join = _require4.join;

var _require5 = require('redial'),
    trigger = _require5.trigger;

var assign = Object.assign;


var serializeLocation = function serializeLocation(_ref) {
  var _ref$basename = _ref.basename,
      basename = _ref$basename === undefined ? '' : _ref$basename,
      _ref$pathname = _ref.pathname,
      pathname = _ref$pathname === undefined ? '' : _ref$pathname,
      _ref$search = _ref.search,
      search = _ref$search === undefined ? '' : _ref$search,
      _ref$hash = _ref.hash,
      hash = _ref$hash === undefined ? '' : _ref$hash;
  return '' + join(basename, pathname) + search + hash;
};

var _require6 = require('../shared'),
    defaultCreateLocals = _require6.defaultCreateLocals,
    defaultStore = _require6.defaultStore,
    ensureRoutes = _require6.ensureRoutes;

var defaultRenderApp = function defaultRenderApp(_ref2) {
  var store = _ref2.store,
      props = _ref2.props;
  return renderToString(React.createElement(Provider, { store: store }, React.createElement(RouterContext, props)));
};

var defaultRenderDocument = function defaultRenderDocument(_ref3) {
  var _ref3$assets = _ref3.assets,
      assets = _ref3$assets === undefined ? [] : _ref3$assets,
      _ref3$content = _ref3.content,
      content = _ref3$content === undefined ? '' : _ref3$content,
      _ref3$state = _ref3.state,
      state = _ref3$state === undefined ? {} : _ref3$state;

  var styles = assets.filter(function (asset) {
    return asset.match(/\.css$/);
  });
  var scripts = assets.filter(function (asset) {
    return asset.match(/\.js$/);
  });

  return '<!DOCTYPE html>' + renderToStaticMarkup(React.createElement(Document, {
    title: 'My App',
    state: state,
    scripts: scripts,
    styles: styles,
    content: content
  }));
};

// ServerAppDefinition {
//   store = ReduxStore,
//   routes = ReactRouterRoutes,
//   renderDocument = HTML -> ReduxStore -> HTML,
//   renderApp = RenderProps -> ReduxStore -> HTML,
//   createLocals = Params -> ReduxStore -> Locals,
//   createStore = State -> ReduxStore,
//   initialState = State
// }

// createServerApp :: ServerAppDefinition -> (Route -> Promise (HTML))

module.exports = function (_ref4) {
  var store = _ref4.store,
      _ref4$assets = _ref4.assets,
      assets = _ref4$assets === undefined ? [] : _ref4$assets,
      _ref4$routes = _ref4.routes,
      routes = _ref4$routes === undefined ? ensureRoutes('createServerApp') : _ref4$routes,
      _ref4$basepath = _ref4.basepath,
      basepath = _ref4$basepath === undefined ? '' : _ref4$basepath,
      _ref4$renderDocument = _ref4.renderDocument,
      renderDocument = _ref4$renderDocument === undefined ? defaultRenderDocument : _ref4$renderDocument,
      _ref4$renderApp = _ref4.renderApp,
      renderApp = _ref4$renderApp === undefined ? defaultRenderApp : _ref4$renderApp,
      _ref4$createLocals = _ref4.createLocals,
      createLocals = _ref4$createLocals === undefined ? defaultCreateLocals : _ref4$createLocals,
      _ref4$createStore = _ref4.createStore,
      createStore = _ref4$createStore === undefined ? defaultStore : _ref4$createStore,
      _ref4$initialState = _ref4.initialState,
      initialState = _ref4$initialState === undefined ? {} : _ref4$initialState;

  var empty = function empty() {
    var storeInstance = store || createStore(initialState);
    var state = storeInstance.getState();
    return renderDocument({ assets: assets, state: state });
  };

  var app = function app(route) {
    return new Promise(function (resolve, reject) {
      var storeInstance = store || createStore(initialState);

      match({ routes: routes, location: route, basename: basepath }, function (error, redirect, props) {
        if (error) {
          return reject(error);
        } else if (redirect) {
          return resolve({
            redirect: serializeLocation(assign(redirect, { basename: basepath }))
          });
        } else if (!props) {
          return reject(new Error('Not found: Route ' + route + ' could not be matched'));
        }

        var components = props.components,
            params = props.params,
            location = props.location;
        var query = location.query;

        var locals = createLocals({ params: params, query: query, store: storeInstance });

        trigger('fetch', components, locals).then(function (res) {
          var content = renderApp({ props: props, store: storeInstance });
          var state = storeInstance.getState();
          var result = renderDocument({
            assets: assets,
            content: content,
            state: state
          });
          resolve({ result: result });
        }).catch(function (error) {
          reject(error);
        });
      });
    });
  };

  app.empty = empty;
  return app;
};


//////////////////
// WEBPACK FOOTER
// ../~/boiler-room-runner/dist/server/index.js
// module id = 824
// module chunks = 0